import type { FC } from 'react';

import { useFinancialValueDisplay } from './financialValueDisplayContextState';
import { FinancialValueDisplayControl } from './FinancialValueDisplayControl';

export const FinancialValueDisplaySurfaceControl: FC = () => {
    const { preference, setSurfacePreference, surfacePreference } = useFinancialValueDisplay();

    if (!setSurfacePreference) {
        return null;
    }

    return (
        <FinancialValueDisplayControl
            allowInherit
            inheritDescription='Follow the account or workspace default without changing its configuration.'
            inheritLabel='Use Account or Workspace Default'
            inheritSectionLabel='Surface Preference'
            resolvedValue={preference}
            value={surfacePreference}
            variant='compact'
            onChange={setSurfacePreference}
        />
    );
};
